import { Pile,iEssence } from 'gci-data-api';

export const essences:iEssence[] = [
  {name: 'EPN',code:'010'},
  {name: 'PIG',code:'043'},
  {name: 'MEL',code:'030'},
  {name: 'SAB',code:'060'},
  {name: 'BOP',code:'105'},
  {name: 'PET',code:'190'},
  {name: 'PEB', code:'191'},
  {name: '199',code:'199'}
];

export const logLengths:number[] = [
  8,9,10,16,17,18,21
];

export const logLengthsLogicMap:{name:number,codes:string[]}[] = [
  {name: 8,  codes: ['105','190','191','199'] },
  {name: 9,  codes: ['010','043','030','060'] },
    {name: 10,  codes: ['010','043','030','060','105','190','191','199'] },
  {name: 16, codes: ['010','043','030','060',] },
  {name: 17,  codes: ['010','043','030','060','105','190','191','199'] },
  {name: 18, codes: ['010','043','030','060'] },
  {name: 21,  codes: ['010','043','030','060','105','190','191','199'] },
];
